<div class="contact-page modal d-flex" *ngIf="isLoaded">
    <form [formGroup]="productForm" class="theme-form">
        <div class="container d-flex justify-content-center">
            <div class="col-10 p-5 modal-body">
                <div class="col-sm-12">
                    <h3>Personalizar precio de los productos:</h3>
                    <p>En esta sección, puedes actualizar los precios del producto. Ingresa el nuevo precio y haz clic
                        en "Guardar" para aplicar los cambios.</p>
                        <div class="row">  
                            <div class="col-sm-12 empty-cart-cls text-center" *ngIf="!products.length">
                                <img src="assets/images/icon-empty-cart.png" class="img-fluid mb-4">
                                <h3><strong>Tu carrito está vacío</strong></h3>
                                <h4>Agrega un producto para poder actualizar el precio.</h4>
                                
                                <div class="d-flex justify-content-center align-items-center gap-3 mt-4">
                                    <button class="btn btn-solid" (click)="cerrarModal()" id="guardarBoton">
                                        <span>Cancelar</span>
                                    </button>&nbsp;
                                </div>
                            </div>
                        </div>
                    <div class="row">
                        <ul class="qty" *ngIf='products.length'>
                            <table class="table cart-table table-responsive-xs">
                                <thead>
                                    <tr class="table-head text-center">
                                        <th scope="col">Producto</th>
                                        <th scope="col">Cantidad</th>
                                        <th scope="col">Precio</th>
                                        <th scope="col">Total</th>
                                    </tr>
                                </thead>
                                <tbody formArrayName="products">
                                    <tr *ngFor="let product of productFormArray.controls; let i = index"
                                        [formGroupName]="i" class="text-center">
                                        <td>{{product.get('title').value}}</td>
                                        <td>{{product.get('quantity').value}}</td>
                                        <td class="d-flex justify-content-center">
                                            <input class="input-custom-price form-control" type="number"
                                                formControlName="price">
                                        </td>
                                        <td>
                                            {{product.get('total').value |
                                            currency:productService?.Currency.currency:'symbol'}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="text-center">
                                <div class="d-flex justify-content-center align-items-center gap-3 mt-4">
                                    <button class="btn btn-solid" (click)="guardar()" id="guardarBoton">
                                        <span>Guardar</span>
                                    </button>&nbsp;
                                    <button class="btn btn-solid" (click)="cerrarModal()" id="guardarBoton">
                                        <span>Cancelar</span>
                                    </button>&nbsp;
                                </div>
                            </div>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>